module.exports = __webpack_public_path__ + "static/media/zfp.adbb662e.png";